import React from "react";
import { SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable from "../tables/AdminAnalyticsTable";
import { aa, formatDateTime, formatDay, formatLabel, formatNumber } from "../adminAnalyticsUtils";
function formatUsersSublabel(count) {
  return aa("users_sublabel", "{{count}} users", {
    count: formatNumber(count),
  });
}
export default function AdminAnalyticsSurveysFeedbackTab({
  data
}) {
  const summary = data?.summary || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("active_surveys", "Active surveys"),
      value: formatNumber(summary.activeSurveys)
    }, {
      label: aa("total_surveys", "Total surveys"),
      value: formatNumber(summary.totalSurveys)
    }, {
      label: aa("survey_responses", "Survey responses"),
      value: formatNumber(summary.surveyResponses)
    }, {
      label: aa("users_responded", "Users responded"),
      value: formatNumber(summary.usersResponded)
    }, {
      label: aa("feedback_entries", "Feedback entries"),
      value: formatNumber(summary.feedbackEntries)
    }, {
      label: aa("feedback_users", "Feedback users"),
      value: formatNumber(summary.feedbackUsers)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("responses_by_day", "Responses by day")} rows={data?.responsesByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.responses} />

        <CssBarChart title={aa("feedback_by_category", "Feedback by category")} rows={data?.feedbackByCategory} getLabel={row => formatLabel(row?.category)} getValue={row => row?.count} />

        <CssBarChart title={aa("feedback_by_area", "Feedback by area")} rows={data?.feedbackByArea} getLabel={row => formatLabel(row?.area)} getValue={row => row?.count} />

        <CssBarChart title={aa("feedback_by_issue_type", "Feedback by issue type")} rows={data?.feedbackByIssueType} getLabel={row => formatLabel(row?.issueType)} getValue={row => row?.count} />

        <CssBarChart title={aa("survey_and_feedback_events", "Survey and feedback events")} rows={data?.surveyFeedbackEvents} getLabel={row => row?.eventName || aa("unknown", "Unknown")} getValue={row => row?.eventCount} getSublabel={row => formatUsersSublabel(row?.uniqueUsers)} />

        <AdminAnalyticsTable title={aa("surveys", "Surveys")} rows={data?.surveys} rowKey={row => row?.surveyId || row?.contentKey} columns={[{
        header: aa("title", "Title"),
        render: row => row?.title || aa("untitled", "Untitled")
      }, {
        header: aa("content_key", "Content key"),
        render: row => row?.contentKey || aa("none", "None")
      }, {
        header: aa("active", "Active"),
        render: row => row?.isActive ? aa("yes", "Yes") : aa("no", "No")
      }, {
        header: aa("published", "Published"),
        render: row => formatDateTime(row?.publishedAt)
      }, {
        header: aa("responses", "Responses"),
        render: row => formatNumber(row?.responseCount)
      }]} />

      </SectionGrid>
    </>;
}
